/**
 * TV screen detection shared by HostPage (display_only mode) and LoginPage (QR login).
 *
 * Full HD TV browsers often report ~960 CSS px (2x scaling), hence the 900 px
 * threshold; smart TV user agents are recognised regardless of reported width.
 */

const TV_MIN_WIDTH_PX = 900
const TV_USER_AGENT = /SMART-TV|SmartTV|Tizen|Web0S|webOS|NetCast|Android TV|AndroidTV|BRAVIA|HbbTV|AFT[A-Z]|CrKey|Roku|VIDAA|Viera/i

export function isTvScreen(): boolean {
  return window.innerWidth > TV_MIN_WIDTH_PX || TV_USER_AGENT.test(navigator.userAgent)
}
